import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '$hooks';
import { IWebRef } from '$models';
import { Link } from '$components/elements/link';
import { Flex } from '$components/layouts';
import { Text } from '$components/elements/text';
import { mq } from '$lib/helpers';

type Props = {
    data: IWebRef;
    productTitle?: string;
};

export const AudioRef: FC<Props> = (props: Props): JSX.Element => {
    const { data, productTitle } = props;
    const { translate } = useTranslation();

    return (
        <Flex column spacingBottom="extrasmall">
            <Text noSpacing h4 size="20px">
                {translate('productPage.webRefs.audio')}
            </Text>
            <DimmedText>{productTitle}</DimmedText>
            <Audio controls>
                <source src={data.uri} type="audio/mpeg" />
                {translate('modals.audioLightBox.downloadLinkPrefix')}
                <Link applyTextStyling={false} href={data.uri}>
                    {translate('modals.audioLightBox.downloadLink')}
                </Link>
                {translate('modals.audioLightBox.downloadLinkPostFix')}
            </Audio>
        </Flex>
    );
};

const DimmedText = styled(Text)(({ theme }) => ({
    color: theme.colors.textSubtle,
    fontSize: theme.fontSizes.xxs,
    marginBottom: theme.space[3],
}));

const Audio = styled.audio({
    [mq(0, 'md')]: {
        width: '100%',
    },
});
